/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

.vitalparameter-import-dialog {
  .MuiPaper-root {
    width: 700px;
    max-width: 700px;
  }

  .trends-table-container {
    height: 400px;
  }

  .trends-table {
    table-layout: fixed;
  }

  .unit {
    color: variables.$color-disabled;
  }
}
